export default __webpack_public_path__ + "static/media/Cell.b453ddd4.png";